import { HTMLAttributes } from "react";
import classNames from "classnames";

// TODO: PanelAppearanceData should probably replace PanelAppearance, also border and boxShadow should be split into more programmatic values rather than strings.

/** A panel appearance. */
interface PanelAppearanceData {

  /** The CSS class name for the appearance. */
  readonly className?: string;
}

interface PanelAppearances {
  readonly [name: string]: PanelAppearanceData
}

export const getPanelAppearanceTable = (styles: Record<string, string>): PanelAppearances => ({
  primary: {
    className: styles.Primary,
  },
  secondary: {
    className: styles.Secondary,
  },
});

export interface StyledPanelProps extends HTMLAttributes<HTMLDivElement> {
  readonly appearance: PanelAppearanceData;
  readonly styles: Record<string, string>;
}

/** The Panel with the appearance styling applied. */
export const StyledPanel = ({ appearance, className, styles, ...props }: StyledPanelProps) => {
  return <div {...props} className={classNames(styles.Panel, appearance.className, className)}>{props.children}</div>;
};
